import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          <span className="text-xs font-medium tracking-wide">LinkedIn</span>
          <FaLinkedin size={22} />
        </>
      ),
      href: "https://www.linkedin.com/in/muhammed-nasmi-088a6628b/",
      style: "rounded-tr-lg",
    },
    {
      id: 2,
      child: (
        <>
          <span className="text-xs font-medium tracking-wide">GitHub</span>
          <FaGithub size={22} />
        </>
      ),
      href: "https://github.com/m-nasmi",
    },
    {
      id: 3,
      child: (
        <>
          <span className="text-xs font-medium tracking-wide">Mail</span>
          <HiOutlineMail size={22} />
        </>
      ),
      href: "mailto:mdnsmi2442@gmail.com",
    },
    {
      id: 4,
      child: (
        <>
          <span className="text-xs font-medium tracking-wide">Resume</span>
          <BsFillPersonLinesFill size={22} />
        </>
      ),
      href: "https://drive.google.com/file/d/1QJYCyW9j0LWugf-MObQZBrbK7qDI6H4l/view?usp=sharing",
      style: "rounded-br-lg",
      download: true,
    },
  ];

  return (
    <div className="hidden lg:flex flex-col top-[38%] left-0 fixed z-30">
      <ul className="flex flex-col gap-0.5">
        {links.map(({ id, child, href, style, download }) => (
          <li key={id}>
            <a
              href={href}
              className={
                "group flex justify-between items-center w-44 h-12 px-4 ml-[-108px] hover:ml-[-6px] duration-300 ease-out bg-slate-800/95 hover:bg-slate-700/95 backdrop-blur-sm border border-white/[0.08] border-l-0 text-slate-200 hover:text-white shadow-lg shadow-black/20 " +
                (style || "")
              }
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
